var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "partner-products ci-card" }, [
    _c("div", { staticClass: "partner_products__header" }, [
      _c("div", { staticClass: "d-flex flex-row" }, [
        _c("div", { staticClass: "flex-column flex-grow-1" }, [
          _c("h2", {
            staticClass: "h2",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.start.partner_products.title")
              ),
            },
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "text-muted",
            domProps: {
              textContent: _vm._s(
                _vm.$t("ui.components.start.partner_products.description")
              ),
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-none d-md-block" },
          [
            _c(_setup.CiButton, {
              attrs: {
                variant: "filled-primary",
                label: _vm.$t("ui.components.start.partner_products.button"),
                to: {
                  name: _vm.$routes.PRODUCTS_SEARCH_INDEX,
                  query: { "toggle[has_product_attachments]": true },
                },
              },
              nativeOn: {
                click: function ($event) {
                  return _setup.emit("tracking-click", {
                    targetName: "ButtonAllProducts",
                    sourceName: "ProductsLibrary",
                  })
                },
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "partner_products__list" },
      [
        _setup.props.loading
          ? [_vm._m(0)]
          : _vm._l(_setup.props.products, function (product) {
              return _c(_setup.CiProductTile, {
                key: product.id,
                attrs: { product: product, "with-border": true },
                on: { "tracking-click": _setup.propagateTrackClick },
              })
            }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "partner_products__footer d-md-none pt-3" },
      [
        _c(_setup.CiButton, {
          staticClass: "w-100",
          attrs: {
            variant: "filled-primary",
            label: _vm.$t("ui.components.start.partner_products.button"),
            to: { name: _vm.$routes.PRODUCTS_SEARCH_INDEX },
          },
          nativeOn: {
            click: function ($event) {
              return _setup.emit("tracking-click", {
                targetName: "ButtonAllProducts",
                sourceName: "ProductsLibrary",
              })
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "loading-spinner d-flex flex-column" }, [
      _c("div", {
        staticClass:
          "d-flex justify-content-center mdi mdi-loading mdi-spin h1 my-auto",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }